export const getApiBaseURL = () => useRuntimeConfig().public.apiBaseUrl as string;

export const fetchWrapper = async <T>(
  url: string,
  options: {
    method:
      | "GET"
      | "HEAD"
      | "PATCH"
      | "POST"
      | "PUT"
      | "DELETE"
      | "CONNECT"
      | "OPTIONS"
      | "TRACE"
      | "get"
      | "head"
      | "patch"
      | "post"
      | "put"
      | "delete"
      | "connect"
      | "options"
      | "trace"
      | undefined;
    headers?: Record<string, string>;
    body?: string | FormData;
    retry?: number | false | undefined;
    credentials?: RequestCredentials | undefined;
    onResponse?: any;
  },
) => {
  return await $fetch<T>(url, {
    method: options.method,
    headers: options.headers,
    body: options.body,
    retry: options.retry,
    credentials: options.credentials,
    onResponse: options.onResponse,
  });
};
